import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as R from "ramda";
import styled from "styled-components";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import UpdatingSpinner from "../ui/UpdatingSpinner";
import {
  specsheetUpdateThumbCut,
  specsheetShowThumbcutModal,
  specsheetDeleteThumbCut,
} from "../specsheet/specsheet.redux";
import * as serialize from "form-serialize";

const lableStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};
const modalStyle = {
  borderBottom: "transparent",
};
const bodyStyle = {
  borderBottom: "transparent",
  padding: "0rem 1rem 1rem 1rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};
const formStyle = {
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "column",
};

const buttonStyle = {
  width: "30px",
  height: "20px",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const doubleButtonStyle = {
  width: "30px",
  height: "100%",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const inputStyle = {
  width: "100%",
  height: "30px",
};
const colStyle = {
  textAlign: "left",
  display: "flex",
  alignItems: "flex-end",
  fontSize: "12px",
  fontWeight: "700",
  letterSpacing: "0px",
  color: "#00197B",
  opacity: "1",
};

const rowStyle = {
  display: "flex",
  alignItems: "center",
};

const rowContainerStyle = {
  display: "flex",
  alignItems: "center",
};

const deleteButtonStyle = {
  color: "#F0142F",
  fontSize: 12,
  background: "none",
  border: "none",
};

const temporalButton = {
  width: "auto",
  height: "auto",
  border: "1px solid var(--unnamed-color-d4d4d5)",
  background: "#00197B 0% 0% no-repeat padding-box",
  border: "1px solid #D4D4D5",
  opacity: "1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "30%",
};

//oval calculation button start
const ButtonCalculateOvalStyle = {
  borderColor: "white",
  backgroundColor: "#20358c",
  fontSize: "18px",
  height: "3em",
  textTransform: "uppercase",
};

const papUDButtonStyleActive = {
  backgroundColor: "#00147B",
  color: "#FFFFFF",
  border: "none",
};

const papUDButtonStyle = {
  backgroundColor: "#FFFFFF",
  color: "#00000099",
  border: "none",
};

const ButtonCalculateOval = ({ className, children, onClick }) => (
  <Button
    type="primary"
    size="large"
    className={className}
    style={ButtonCalculateOvalStyle}
    onClick={onClick}
  >
    {children}
  </Button>
);
//oval calculation button end

// export const ModalBowlers = ({ tittle = 'Oval Width', isEdit, setShow, show, value, name, openDropdown }) => {
const ModalRedux = (props) => {
  const { t } = useTranslation();
  const [currentThumbcut, setCurrentThumbcut] = useState({
    ...props.thumbcutSelected,
    v: (props.thumbcutSelected.v * 1).toFixed(3),
    h: (props.thumbcutSelected.h * 1).toFixed(3),
  });
  const formRef = useRef();

  const {
    initialValues,
    updatingValues,
    showThumbcutModal,
    appSettings,
    flip_vh,
    specsheetUpdateThumbCut,
    specsheetShowThumbcutModal,
    specsheetDeleteThumbCut,
    thumbcutSelected,
  } = props;

  const handleClose = () => {
    specsheetShowThumbcutModal({ show: false });
  };

  const handleUpdate = () => {
    debugger;
    const form = formRef.current;
    const values = serialize(form, { hash: true });
    const updatedCut = {
      ...thumbcutSelected,
      v: (values.v * 1).toFixed(3),
      h: (values.h * 1).toFixed(3),
    };
    specsheetUpdateThumbCut(updatedCut);
  };

  const handleDelete = () => {
    specsheetShowThumbcutModal({ show: false });
    specsheetDeleteThumbCut(thumbcutSelected);
  };

  return (
    <>
      {/* TODO: implementation with redux */}
      {/* <Button onClick={handleShow} style={temporalButton}>
        Modal Temporal
      </Button> */}

      <Modal
        size="sm"
        show={showThumbcutModal}
        onHide={handleClose}
        centered
        className={`select-modal thumbcut`}
      >
        <Modal.Header closeButton style={modalStyle}>
          <span style={lableStyle}>
            <span style={{ marginRight: 5 }}>{t(`form.label.thumbcut`)}</span>
            <span
              dangerouslySetInnerHTML={{
                __html: currentThumbcut.label,
              }}
            />
          </span>
        </Modal.Header>
        {updatingValues ? (
          <Modal.Body style={bodyStyle}>
            <UpdatingSpinner />
          </Modal.Body>
        ) : (
          <Modal.Body style={bodyStyle}>
            <Form ref={formRef}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
                style={formStyle}
              >
                <div className="row" style={rowContainerStyle}>
                  {flip_vh === "vh" ? (
                    <div className="col-10">
                      <div className="row" style={rowStyle}>
                        <div className="col-2" style={colStyle}>
                          V:
                        </div>
                        <div
                          className="col-2"
                          style={{ ...colStyle, padding: 0 }}
                        >
                          <Button
                            onClick={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const vValue = values.v * -1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                v: vValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            style={buttonStyle}
                          >
                            -
                          </Button>
                        </div>
                        <div className="col-8" style={{ padding: 0 }}>
                          <Form.Control
                            value={currentThumbcut.v}
                            onChange={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const vValue = values.v * 1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                v: vValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            step="0.001"
                            type="number"
                            placeholder=""
                            autoFocus
                            style={inputStyle}
                            name="v"
                          />
                        </div>
                      </div>
                      <div className="row" style={rowStyle}>
                        <div className="col-2" style={colStyle}>
                          H:
                        </div>
                        <div
                          className="col-2"
                          style={{ ...colStyle, padding: 0 }}
                        >
                          <Button
                            onClick={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const hValue = values.h * -1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                h: hValue, // suspect line
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            style={buttonStyle}
                          >
                            -
                          </Button>
                        </div>
                        <div className="col-8" style={{ padding: 0 }}>
                          <Form.Control
                            value={currentThumbcut.h}
                            onChange={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const hValue = values.h * 1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                h: hValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            step="0.001"
                            type="number"
                            placeholder=""
                            autoFocus
                            style={inputStyle}
                            name="h"
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="col-10">
                      <div className="row" style={rowStyle}>
                        <div className="col-2" style={colStyle}>
                          H:
                        </div>
                        <div
                          className="col-2"
                          style={{ ...colStyle, padding: 0 }}
                        >
                          <Button
                            onClick={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const hValue = values.h * -1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                h: hValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            style={buttonStyle}
                          >
                            -
                          </Button>
                        </div>
                        <div className="col-8" style={{ padding: 0 }}>
                          <Form.Control
                            value={currentThumbcut.h}
                            onChange={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const hValue = values.h * 1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                h: hValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            step="0.001"
                            type="number"
                            placeholder=""
                            autoFocus
                            style={inputStyle}
                            name="h"
                          />
                        </div>
                      </div>
                      <div className="row" style={rowStyle}>
                        <div className="col-2" style={colStyle}>
                          V:
                        </div>
                        <div
                          className="col-2"
                          style={{ ...colStyle, padding: 0 }}
                        >
                          <Button
                            onClick={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const vValue = values.v * -1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                v: vValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            style={buttonStyle}
                          >
                            -
                          </Button>
                        </div>
                        <div className="col-8" style={{ padding: 0 }}>
                          <Form.Control
                            value={currentThumbcut.v}
                            onChange={() => {
                              const form = formRef.current;
                              const values = serialize(form, { hash: true });
                              const vValue = values.v * 1;
                              const updatedCut = {
                                ...thumbcutSelected,
                                ...values,
                                v: vValue,
                              };
                              setCurrentThumbcut(updatedCut);
                            }}
                            step="0.001"
                            type="number"
                            placeholder=""
                            autoFocus
                            style={inputStyle}
                            name="v"
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="col-2"
                    style={{ height: 60, padding: 0, paddingLeft: 3 }}
                  >
                    <Button onClick={handleUpdate} style={doubleButtonStyle}>
                      <FontAwesomeIcon icon={["fas", "arrow-down"]} />
                    </Button>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ ...rowContainerStyle, marginTop: 5 }}
                >
                  <div className="col-12">
                    <Button
                      variant="light"
                      onClick={handleDelete}
                      style={deleteButtonStyle}
                    >
                      {t(`form.label.deleteThumbcut`)}
                    </Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export const ModalThumbCut = connect(
  (state) => {
    return {
      showThumbcutModal: state.specsheet.showThumbcutModal,
      appSettings: state.settings.appSettings,
      updatingValues: state.specsheet.updatingThumbcut,
      thumbcutSelected: state.specsheet.thumbcutSelected,
      flip_vh: state.settings.appSettings.thumbHolePreferences.flip_vh,
    };
  },
  {
    specsheetUpdateThumbCut,
    specsheetShowThumbcutModal,
    specsheetDeleteThumbCut,
  }
)(ModalRedux);
